import {IDataBloodmagicItem} from "../_interfaces/IDataBloodmagicItem";

const bloodmagic_items: IDataBloodmagicItem[] =
    [
        {
            name: 'Astralauge',
            dmg: 2,
            strain: 1,
            price: 325,
            avail: 'Ungewöhnlich',
            desc: ['Ein Astralauge ist ein magisch behandelter Bernsteinklumpen, der ausgehöhlt, mit einer Nährlösung und einem Gelwurm gefüllt und dann an einer Augenklappe befestigt wird. ',
                'Wenn es eingesetzt wird, bohrt sich der Wurm in das Auge des Charakters und zerstört es dabei. ',
                'Auch wenn die Nährlösung diesen Vorgang recht schmerzlos macht, verursacht er 2 permanente Schadenspunkte. ',
                'Sobald das Amulett eingesetzt wurde, kann es nicht mehr entfernt werden, und der Schaden kann nie wieder geheilt werden. ',
                'Die normale Sicht des Charakters durch den Bernstein ist zwar etwas trübe, aber dafür kann er mit dem Auge in den Astralraum sehen, als besäße er das Talent Astralsicht. ' +
                'Der Charakter erhält einen Bonus von +1 auf Astrale Spürproben, die er mit seiner Wahrnehmungsstufe ablegt. ' +
                'Wenn er das Talent Astralsicht beherrscht, erhält er einen Bonus von +1 auf seine Astralsicht-Probe. ' +
                'Jedes Mal, wenn der Charakter das Auge auf diese Weise verwendet, erleidet er 1 Punkt Überanstrengung.']
        },
        {
            name: 'Dämonenabwehr',
            dmg: 3,
            strain: 1,
            strain_mods: [
                {what: 'kv', mod: 3, type: 'rounds', duration: 1},
                {what: 'mv', mod: 3, type: 'rounds', duration: 1}
            ],
            price: 500,
            avail: 'Ungewöhnlich',
            desc: ['Dämonenabwehramulette werden aus einem Stück Wahrer Erde gefertigt, das in Gold und Silber eingesetzt ist. ',
                'Zwei Tropfen Blut des Charakters rinnen auf dem Gold entlang, versickern in der Erde, kommen aus dem Silber wieder hervor und versickern wieder in der Erde, worauf der Zyklus von Neuem beginnt. ',
                'Das Einpflanzen des Amuletts fügt dem Charakter 3 Punkte Blutmagieschaden zu. Dämonenabwehramulette bieten Schutz vor Dämonen und ihren Konstrukten. ',
                'Für 1 Punkt Überanstrengung pro Runde addiert der Charakter +3 zu seiner Körperlichen und Mystischen Verteidigung gegen Dämonen und Dämonenkonstrukte. ',
                'Wenn der Charakter das Amulett wieder deaktiviert, fällt es von seinem Körper ab und geht in einen Ruhezustand über. ' +
                'Es kann wieder befestigt werden, sobald der Charakter den durch das Amulett verursachten Schaden geheilt hat.']
        },
        {
            name: 'Garlenstein',
            dmg: 4,
            strain: 2,
            price: 250,
            avail: 'Selten',
            desc: ['Garlensteine sind kleine Kiesel, die von goldenen raupenähnlichen Haaren bedeckt sind. ' +
            'Wenn ein Garlenstein geschluckt wird, verlängern sich die Haare zu Dornen und befestigen den Stein an der Magen- oder Darmwand des Charakters. ',
                'Durch das Schlucken eines Garlensteins erleidet der Charakter 4 permanente Schadenspunkte; der Stein kann nicht mehr entfernt werden, ohne den Charakter dabei zu töten. ',
                'Aus diesem Grund kann auch der Schaden, der durch das Schlucken eines Garlensteins verursacht wird, nie geheilt werden. ',
                'Für 2 Punkte Überanstrengung kann der Charakter einmal am Tag eine seiner Erholungsproben einsetzen, um eine Wunde statt Schadenspunkte zu heilen. ',
                'Der Garlenstein kann erst wieder verwendet werden, wenn der Charakter alle erlittenen Wunden und Schadenspunkte geheilt hat, und niemals zweimal am selben Tag. ' +
                'Garlensteine können nur von Garlenquestoren hergestellt werden.']
        },
        {
            name: 'Hornnadel',
            dmg: 3,
            strain: 2,
            strain_mods: [
                {what: 'zae', mod: 3, type: 'rounds', duration: 1},
                {what: 'mv', mod: 3, type: 'rounds', duration: 1}
            ],
            price: 450,
            avail: 'Selten',
            desc: ['Diese Amulette sind kleine Stücke aus Elfenbein oder anderem tierischen Horn, die sorgfältig zu dünnen Nadeln geschnitzt wurden. ',
                'Wenn die Nadel unter der Haut des Charakters eingepflanzt wird, verfärbt sie sich von einem gelblichen Grau zu Rot mit schwarzen Streifen und bleibt durch die Haut sichtbar. ',
                'Dadurch erleidet der Charakter 3 Punkte Blutmagieschaden. ',
                'Das Amulett erhöht die Resistenz des Charakters gegen Gifte und Krankheiten. ',
                'Für 2 Punkte Überanstrengung erhält der Charakter einen Bonus von +3 auf Proben, die auf Zähigkeit basieren, oder addiert +3 zu seiner Mystischen Verteidigung, wenn er den Auswirkungen von Krankheiten oder Giften widersteht.']
        },
        {
            name: 'Initiativeverstärker',
            dmg: 4,
            strain: 1,
            strain_mods: [
                {what: 'ini', mod: 1, type: 'rounds', duration: 1}
            ],
            price: 600,
            avail: 'Selten',
            desc: ['Initiativeverstärkeramulette werden aus rubinroten Kristallen gefertigt und färben sich so schwarz wie Obsidian, wenn sie das Blut des Charakters aufsaugen. ',
                'Durch das Einpflanzen des Amuletts erleidet der Charakter 4 Punkte Blutmagieschaden. ',
                'Das Amulett gewährt ihm einen Bonus auf Initiativeproben: Für jeden Punkt Überanstrengung, den der Charakter erleidet, erhält er einen Bonus von +1 auf seine Initiativeprobe. ',
                'Der Charakter muss die Verwendung des Amuletts sowie die Menge an Überanstrengung ankündigen, die er auf sich nehmen will, bevor er seine Initiativeprobe ablegt.']
        },
        {
            name: 'Knochenamulett',
            dmg: 1,
            strain: 0,
            strain_mods: [
                {what: 'ep', mod: 1, type: 'constant', duration: 0}
            ],
            price: 175,
            avail: 'Selten',
            desc: ['Viele Orkstämme fertigen magische Amulette aus den Knochen toter Feinde, die tapfer gekämpft haben, in der Hoffnung, dass die Stärke und der Mut des toten Gegners auf sie übergehen. ',
                'Sie sind in zwei Versionen erhältlich:\nGewöhnliche Knochenamulette sind kleine, unbearbeitete knöchelgroße Knochenstücke, die mit einer Metallnadel in die Haut des Charakters eingesetzt werden. ',
                'Das Einpflanzen des Amuletts fügt dem Charakter 1 Punkt Blutmagieschaden zu und verleiht ihm einen Bonus von +1 auf seine Erholungsproben.',
                'Geformte Knochenamulette werden nur von Stammeshäuptlingen oder Zauberern getragen und sind meist zu Formen umgearbeitet, die eine Bedeutung für den Träger haben; oft sind dies rohe oder auch sehr fein gearbeitete Bilder einer der Passionen. ' +
                'Diese Amulette können bis zu vier Zoll lang sein, werden in den Unterarm des Charakters eingepflanzt und sind ansonsten mit Amuletten des Treffer Auffangen identisch.']
        },
        {
            name: 'Kraftverstärker',
            dmg: 2,
            strain: 2,
            strain_mods: [
                {what: 'str', mod: 1, type: 'rounds', duration: 1}
            ],
            price: 300,
            avail: 'Selten',
            desc: ['Kraftverstärker bestehen am häufigsten aus farblosem Kristall, der tiefrot wird, wenn das Blut des Trägers ihn aktiviert. ',
                'Diese Amulette gewähren dem Träger einen Bonus auf Stärkeproben; pro 2 Punkte Überanstrengung, die der Charakter erleidet, erhält er einen Bonus von +1 auf reine Stärkeproben. ',
                'Ein Kraftverstärker kann nicht zur Erhöhung von Schadensproben im Kampf verwendet werden. ',
                'Das Einpflanzen eines Kraftverstärkers fügt dem Charakter 2 Punkte Blutmagieschaden zu.']
        },
        {
            name: 'Letzte Rettung',
            dmg: 3,
            strain: 1,
            price: 450,
            avail: 'Ungewöhnlich',
            desc: ['Dieses Amulett wird gewöhnlich aus Türkis oder Turmalin gefertigt und weist einen charakteristischen roten Punkt auf, der durch das Blut des Trägers verursacht wird. ',
                'Das Einpflanzen eines Amuletts der Letzten Rettung fügt dem Charakter 3 Punkte Blutmagieschaden zu. ',
                'Wenn der Charakter stirbt, erlaubt ihm das Amulett, eine Erholungsprobe mit einem Bonus von +6 abzulegen. ',
                'Sollte er keine Erholungsprobe mehr übrig haben, gewährt ihm das Amulett eine zusätzliche Erholungsprobe mit Stufe 6. ',
                'Wenn das Ergebnis hoch genug ist, um den Aktuellen Schaden des Charakters unter seine Todesschwelle zu bringen, kehrt er ins Leben zurück, ansonsten bleibt er tot. ',
                'Nachdem das Amulett benutzt wurde, verliert es seine Macht und erscheint als durchsichtiger, fast farbloser Stein. ',
                'Obwohl es danach an sich keinen Wert mehr hat, bieten Adlige und Möchtegern-Helden manchmal bis zu 100 Silberstücke für ein gebrauchtes Amulett der Letzten Rettung und tragen es offen als unverdientes Ehrenabzeichen.']
        },
        {
            name: 'Nachtsichtauge',
            dmg: 2,
            strain: 0,
            price: 200,
            avail: 'Ungewöhnlich',
            desc: ['Ein Nachsichtauge ist ein magisch behandelter lebendiger Kristall, der ausgehöhlt, mit einer Nährlösung und einem Gelwurm gefüllt und dann an einer Augenklappe befestigt wird. ',
                'Wenn es eingesetzt wird, bohrt sich der Wurm in das Auge des Charakters und zerstört es dabei. ',
                'Auch wenn die Nährlösung diesen Vorgang recht schmerzlos macht, verursacht er 2 permanente Schadenspunkte. ',
                'Sobald das Amulett eingesetzt wurde, kann es nicht mehr entfernt werden, und der Schaden kann nie wieder geheilt werden. ',
                'Die normale Sicht des Charakters durch den Kristall ist zwar etwas trübe, aber dafür kann er mit dem Auge im Dunkeln sehen, als besäße er die Rassenfähigkeit Nachtsicht. ',
                'Ein Charakter, der diese Fähigkeit bereits besitzt, erhält durch das Tragen eines Nachtsichtauges keinen zusätzlichen Vorteil.']
        },
        {
            name: 'Standhaftigkeit',
            dmg: 3,
            strain: 1,
            price: 200,
            avail: 'Ungewöhnlich',
            desc: ['Standhaftigkeitsamulette werden aus bernsteinfarbenem Kristall gefertigt und verdunkeln sich zu einem tiefen Orange, wenn sie durch das Blut des Trägers aktiviert werden. ',
                'Das Einpflanzen eines Standhaftigkeitsamuletts fügt dem Charakter 3 Punkte Blutmagieschaden zu. ',
                'Für 1 Punkt Überanstrengung erhält er einen Bonus von +3 auf eine Niederschlagsprobe.']
        },
        {
            name: 'Treffer Auffangen',
            dmg: 2,
            strain: 0,
            price: 100,
            avail: 'Ungewöhnlich',
            desc: ['Diese Amulette bestehen gewöhnlich aus Quarz und sind durch das Blut des Charakters von roten Adern durchzogen. ',
                'Das Einpflanzen des Amuletts verursacht 2 Punkte Blutmagieschaden. ',
                'Wenn es aktiviert wird, absorbiert es die ersten 12 Schadenspunkte, die dem Charakter zugefügt werden. ',
                'Ein Charakter kann das Amulett nicht benutzen, wenn er Überrascht ist oder aus dem Toten Winkel angegriffen wird. ',
                'Nachdem es 12 Schadenspunkte absorbiert hat, ist das Amulett zerstört – übrig bleibt nur noch ein gesprungener schwarzer Stein.']
        },
        {
            name: 'Verzweiflungsschlag',
            dmg: 3,
            strain: 0,
            price: 275,
            avail: 'Ungewöhnlich',
            desc: ['Amuletthersteller fertigen Verzweiflungsschlagamulette gewöhnlich aus Stahl und Quarz. ',
                'Das Einpflanzen des Amuletts fügt dem Charakter 3 Punkte Blutmagieschaden zu. ',
                'Das Blut des Charakters färbt den Quarz rötlich, und ein Tropfen Blut bleibt dauerhaft auf dem Stahl sichtbar. ',
                'Wenn ein Verzweiflungsschlagamulett aktiviert wird, gewährt es nach Wahl des Charakters einen Bonus von +6 auf eine Angriffs- oder Schadensprobe. ',
                'Das Amulett kann nach Gebrauch wieder aufgeladen werden, wozu der Charakter aber erst den Blutmagieschaden durch das Amulett geheilt haben muss.']
        },
        {
            name: 'Verzweiflungszauber',
            dmg: 3,
            strain: 0,
            price: 300,
            avail: 'Ungewöhnlich',
            desc: ['Ein Verzweiflungszauberamulett wird aus Silber und einer kleinen Perle gefertigt und fügt dem Charakter beim Einpflanzen 3 Punkte Blutmagieschaden zu. ',
                'Das Blut des Charakters hinterlässt hellrote Sprenkel auf der Perle. Wenn ein Verzweiflungszauberamulett aktiviert wird, gewährt es nach Wahl des Charakters einen Bonus von +6 auf eine Spruchzauberei- oder Zauberwirkungsprobe. ',
                'Das Amulett kann nach Gebrauch wieder aufgeladen werden, wozu der Charakter aber erst den Blutmagieschaden durch das Amulett geheilt haben muss.']
        },
        {
            name: 'Wurmauge',
            dmg: 2,
            strain: 1,
            price: 450,
            avail: 'Ungewöhnlich',
            desc: ['Ein Wurmauge ist ein magisch behandeltes Stück Quarz, das ausgehöhlt, mit einer Nährlösung und einem Gelwurm gefüllt und dann an einer Augenklappe befestigt wird. ',
                'Wenn er eingesetzt wird, bohrt sich der Wurm in das Auge des Charakters und zerstört es dabei. ',
                'Auch wenn die Nährlösung diesen Vorgang recht schmerzlos macht, verursacht er 2 permanente Schadenspunkte. ',
                'Sobald das Amulett eingesetzt wurde, kann es nicht mehr entfernt werden, und der Schaden kann nie wieder geheilt werden. ',
                'Der Charakter sieht normal durch den Quarz, auch wenn seine Sicht etwas getrübt ist. ',
                'Für 1 Punkt Überanstrengung erhält er einen Bonus von +2 auf seine nächste Fernkampfangriffsprobe. ',
                'Sofern der Charakter durch Talente oder andere Fähigkeiten (wie z. B. Zweiter Schuss) mehrere Fernkampfangriffsproben pro Runde ablegen kann, darf er für die entsprechende Überanstrengung die Fähigkeiten des Wurmauges auch mehrfach einsetzen.']
        }
    ]

export default bloodmagic_items;